import { Link } from 'react-router-dom';
import { selectImage } from '../../../util/misc';
import NotFound from './not-found';
import { useContext } from 'react';
import { CategoriesContext } from '../../../App';

function OniCategoryOuter() {
    const { currentCategory } = useContext(CategoriesContext);
    if (!currentCategory) {
        return <NotFound>Раздел не найден</NotFound>;
    }
    return (
        <div className="col-md-9">
            {currentCategory.children?.map((cat) => {
                const childrenImages =
                    cat.children?.map((c) => selectImage(c.imageVariants, 200, 50, c.imageUrl)) || [];
                return (
                    <Link
                        key={cat.slug}
                        to={cat.url}
                        className="iek-prodcat-catalog-section-list-subsections-section"
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <h2 style={{ color: '#2b4244' }}>{cat.name}</h2>
                                        <div style={{ marginTop: '10px' }}>
                                            {childrenImages.map((img, idx) => (
                                                <img
                                                    key={idx}
                                                    src={img}
                                                    alt=""
                                                    style={{
                                                        maxWidth: '60px',
                                                        maxHeight: '60px',
                                                        verticalAlign: 'middle',
                                                        marginRight: '10px',
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Link>
                );
            })}
        </div>
    );
}

export default OniCategoryOuter;
